import { Type } from 'class-transformer'
import { ScenarioCategory } from '@app/features/scope-overview/model/scenario-category.model'
import { AuditMetadata } from '@core/model/auditMetadata.model'
import { TableColumnKey } from '@shared/components/ui-components/scope-ui-table/table-column-key.enum'

export class Scenario {
  id!: number
  name!: string
  state: string = TableColumnKey.PUBLISHED
  @Type(() => ScenarioCategory) categories: ScenarioCategory[] = []
  @Type(() => AuditMetadata) auditMetadata!: AuditMetadata
}
